"use client";

import React from "react";
import { ArrowRight, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const statsData = [{
  value: "Misión",
  label: "Nuestro Propósito",
  description: "Entregar soluciones industriales sostenibles e innovadoras que impulsen el crecimiento de nuestros clientes con la más alta calidad en acero."
}, {
  value: "Visión",
  label: "Hacia el Futuro",
  description: "Ser líderes indiscutibles en el mercado del acero, reconocidos por nuestra excelencia operativa y compromiso con el desarrollo tecnológico."
}, {
  value: "Valores",
  label: "Nuestros Pilares",
  description: "Integridad, Innovación, Sostenibilidad y Excelencia son los principios que guían cada una de nuestras acciones y decisiones corporativas."
}];
const avatars = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/team_expert_1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/team_expert_1.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/team_expert_1.png-wvc-sizes",
  alt: "Experto en Acero 1"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/team_expert_2.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/team_expert_2.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/team_expert_2.png-wvc-sizes",
  alt: "Experto en Acero 2"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/team_expert_3.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/team_expert_3.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/team_expert_3.png-wvc-sizes",
  alt: "Experto en Acero 3"
}];
export default function MissionVisionValues() {
  const {
    ref: leftColRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightColRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="254628" id="mission-vision-values" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {}
          <div ref={leftColRef} className={`flex flex-col transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="mb-6 flex items-center gap-2">
              <span className="text-primary font-default font-bold text-xs tracking-widest uppercase">
                Filosofía Corporativa
              </span>
            </div>

            <h2 className="font-default text-4xl md:text-5xl lg:text-[3.5rem] font-bold leading-[1.1] mb-8 text-foreground">
              Comprometidos con la{" "}
              <span className="text-primary font-normal">
                excelencia industrial y la innovación constante para forjar un
                futuro sólido y sostenible en la industria del acero.
              </span>
            </h2>

            <div className="flex flex-wrap items-center gap-6 mb-16">
              <Link to="/NosotrosPage">
                <Button size="lg" className="bg-primary hover:bg-primary-600 text-primary-foreground rounded-lg px-8 h-14 text-base font-default shadow-md transition-all">
                  Conoce nuestra historia
                  <ArrowRight className="ml-2 size-5" />
                </Button>
              </Link>

              <div className="flex items-center">
                <div className="flex -space-x-3">
                  {avatars.map((avatar, i) => <div key={i} data-index={i} className="w-12 h-12 rounded-lg border-2 border-background overflow-hidden bg-muted shadow-sm">
                      <img src={avatar.src} data-wvc-srcset={avatar.srcset} data-wvc-sizes={avatar.sizes} alt={avatar.alt} className="w-full h-full object-cover" loading="lazy" />
                    </div>)}
                </div>
                <div className="w-12 h-12 rounded-lg border-2 border-background bg-accent text-accent-foreground flex items-center justify-center -ml-3 z-10 text-sm font-default font-bold shadow-sm">
                  +
                </div>
              </div>
            </div>

            {}
            <div className="relative w-48 h-48 md:w-64 md:h-64 rounded-lg overflow-hidden bg-muted shadow-xl group cursor-pointer">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_steel_facility.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_steel_facility.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_steel_facility.png-wvc-sizes" alt="Planta Industrial Kalisch" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-90" loading="lazy" />
              <div className="absolute inset-0 bg-primary/20 group-hover:bg-primary/30 transition-colors duration-300" />
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-background rounded-lg flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform duration-300">
                <Play className="size-6 text-secondary ml-1" fill="currentColor" />
              </div>
            </div>
          </div>

          {}
          <div ref={rightColRef} className={`flex flex-col gap-6 transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {statsData.map((stat, i) => <div key={i} data-index={i} className="bg-card rounded-2xl p-8 shadow-md border border-border/40 hover:border-primary/30 hover:shadow-lg transition-all duration-300 flex flex-col md:flex-row gap-6 md:gap-8 items-start md:items-center">
                <div className="min-w-[140px]">
                  <h3 className="font-default text-4xl md:text-5xl font-bold text-primary mb-2">
                    {stat.value}
                  </h3>
                  <p className="font-default text-xs font-bold text-secondary uppercase tracking-widest">
                    {stat.label}
                  </p>
                </div>
                <div className="hidden md:block w-px h-16 bg-border/60" />
                <p className="font-default text-muted-foreground text-sm leading-relaxed flex-1">
                  {stat.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}